// extracted by mini-css-extract-plugin
module.exports = {"comment":"ProductCommentsFormatter_comment__33Ufu","commentCount":"ProductCommentsFormatter_commentCount__3TDOs"};